import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import apiNetCore from '../../../../services/apiNetCore';
import CarregamentosGraph from './CarregamentosGraph';
import LotesTable from './LotesTable';
import { Container } from './styles';

const Performance = () => {
  const params = useParams();
  const [idLotes, setIdLotes] = useState([]);

  useEffect(() => {
    const onInit = async () => {
      const { data } = await apiNetCore.get(`demanda/${params.demandaId}`);

      setIdLotes(data.lotes.map(lote => lote.idLote));
    };

    onInit();
  }, [params.demandaId]);

  return (
    <Container>
      <CarregamentosGraph idLotes={idLotes} />
      <LotesTable idLotes={idLotes} />
    </Container>
  );
};

export default Performance;
